module.exports = __webpack_public_path__ + "img/badge-recommendations-silver-brightbg.b26b9a26.svg";